import { canAdjustPosition, getBoundsFromDOMRect, getScreenBounds, isBoundsInsideScreen, isPositionBottom, isSubPositionCenter, isSubPositionEnd, isPositionHorizontal, isPositionLeft, isPositionRight, isSubPositionStart, isPositionTop, isPositionVertical, POPOVER_OFFSET, POPOVER_CARET_SIZE, } from './PopoverUtil';
const CARET_LONGEST_SIDE = Math.ceil(Math.sqrt(Math.pow(POPOVER_CARET_SIZE, 2) * 1.5));
const PREFERED_POSITIONS = {
    top: ['top', 'bottom'],
    bottom: ['bottom', 'top'],
    left: ['left', 'top,', 'right', 'bottom'],
    right: ['right', 'bottom', 'left', 'top'],
};
function getPositionsByPreferedPosition(position) {
    if (isPositionTop(position)) {
        return PREFERED_POSITIONS.top;
    }
    if (isPositionBottom(position)) {
        return PREFERED_POSITIONS.bottom;
    }
    if (isPositionLeft(position)) {
        return PREFERED_POSITIONS.left;
    }
    return PREFERED_POSITIONS.right;
}
function calculateBoundsFromPosition({ position, trigger, content }) {
    let x = trigger.x;
    let y = trigger.y;
    const horizontalCaretDelta = Math.max(0, CARET_LONGEST_SIDE - trigger.width);
    const verticalCaretDelta = Math.max(0, CARET_LONGEST_SIDE - trigger.height);
    if (isPositionVertical(position)) {
        if (isPositionTop(position)) {
            y -= content.height + POPOVER_OFFSET;
        }
        if (isPositionBottom(position)) {
            y += trigger.height + POPOVER_OFFSET;
        }
        if (isSubPositionStart(position)) {
            x = trigger.x - horizontalCaretDelta;
        }
        if (isSubPositionCenter(position)) {
            x += Math.round((trigger.width - content.width) / 2);
        }
        if (isSubPositionEnd(position)) {
            x += trigger.width - content.width + horizontalCaretDelta;
        }
    }
    if (isPositionHorizontal(position)) {
        if (isPositionLeft(position)) {
            x -= content.width + POPOVER_OFFSET;
        }
        if (isPositionRight(position)) {
            x += trigger.width + POPOVER_OFFSET;
        }
        if (isSubPositionStart(position)) {
            y = trigger.y - verticalCaretDelta;
        }
        if (isSubPositionCenter(position)) {
            y += Math.round((trigger.height - content.height) / 2);
        }
        if (isSubPositionEnd(position)) {
            y += trigger.height - content.height + verticalCaretDelta;
        }
    }
    return { x, y, width: content.width, height: content.height };
}
export const calculatePopoverCoordinates = ({ position: preferedPosition, triggerBounds: triggerDOMRect, contentBounds: contentDOMRect, }) => {
    let result = null;
    const [, alignment] = preferedPosition.split('-');
    const screen = getScreenBounds();
    const trigger = getBoundsFromDOMRect(triggerDOMRect);
    const content = getBoundsFromDOMRect(contentDOMRect);
    const positions = getPositionsByPreferedPosition(preferedPosition);
    positions.find((pos) => {
        const composedPosition = `${pos}-${alignment}`;
        const targetContentBounds = calculateBoundsFromPosition({
            position: composedPosition,
            trigger,
            content,
        });
        if (isBoundsInsideScreen(targetContentBounds, trigger, screen) ||
            canAdjustPosition({ position: composedPosition, trigger, content: targetContentBounds, screen })) {
            result = {
                trigger,
                content: targetContentBounds,
                position: composedPosition,
            };
            return true;
        }
    });
    return result;
};
